/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MstCenterSupplier
 */
export interface MstCenterSupplier {
    /**
     * 
     * @type {number}
     * @memberof MstCenterSupplier
     */
    companyId: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterSupplier
     */
    centerId: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterSupplier
     */
    orgCenterId: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterSupplier
     */
    orgSupplierId: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterSupplier
     */
    optimizeType: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterSupplier
     */
    optimizeRange: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterSupplier
     */
    arrivalRatioMon: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterSupplier
     */
    arrivalRatioTue: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterSupplier
     */
    arrivalRatioWed: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterSupplier
     */
    arrivalRatioThu: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterSupplier
     */
    arrivalRatioFri: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterSupplier
     */
    arrivalRatioSat: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterSupplier
     */
    arrivalRatioSun: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterSupplier
     */
    stopArrival: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterSupplier
     */
    minOrderQuantityOnce: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterSupplier
     */
    orderLeadtime: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterSupplier
     */
    orderLimitTime: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterSupplier
     */
    enableShipdayMon: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterSupplier
     */
    enableShipdayTue: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterSupplier
     */
    enableShipdayWed: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterSupplier
     */
    enableShipdayThu: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterSupplier
     */
    enableShipdayFri: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterSupplier
     */
    enableShipdaySat: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterSupplier
     */
    enableShipdaySun: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MstCenterSupplier
     */
    enableSupplierShipday: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterSupplier
     */
    remarks: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenterSupplier
     */
    deleteFlg: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCenterSupplier
     */
    insertDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterSupplier
     */
    insertUser: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCenterSupplier
     */
    updateDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterSupplier
     */
    updateUser: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCenterSupplier
     */
    deleteDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterSupplier
     */
    deleteUser: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterSupplier
     */
    trMinOrderQuantityOnce: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterSupplier
     */
    trOrderLeadtime: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterSupplier
     */
    trOrderLimitTime: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterSupplier
     */
    orderTiming: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenterSupplier
     */
    monthlyOrderLimitDay: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenterSupplier
     */
    monthlyOrderTarget: string | null;
}

/**
 * Check if a given object implements the MstCenterSupplier interface.
 */
export function instanceOfMstCenterSupplier(value: object): value is MstCenterSupplier {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('centerId' in value) || value['centerId'] === undefined) return false;
    if (!('orgCenterId' in value) || value['orgCenterId'] === undefined) return false;
    if (!('orgSupplierId' in value) || value['orgSupplierId'] === undefined) return false;
    if (!('optimizeType' in value) || value['optimizeType'] === undefined) return false;
    if (!('optimizeRange' in value) || value['optimizeRange'] === undefined) return false;
    if (!('arrivalRatioMon' in value) || value['arrivalRatioMon'] === undefined) return false;
    if (!('arrivalRatioTue' in value) || value['arrivalRatioTue'] === undefined) return false;
    if (!('arrivalRatioWed' in value) || value['arrivalRatioWed'] === undefined) return false;
    if (!('arrivalRatioThu' in value) || value['arrivalRatioThu'] === undefined) return false;
    if (!('arrivalRatioFri' in value) || value['arrivalRatioFri'] === undefined) return false;
    if (!('arrivalRatioSat' in value) || value['arrivalRatioSat'] === undefined) return false;
    if (!('arrivalRatioSun' in value) || value['arrivalRatioSun'] === undefined) return false;
    if (!('stopArrival' in value) || value['stopArrival'] === undefined) return false;
    if (!('minOrderQuantityOnce' in value) || value['minOrderQuantityOnce'] === undefined) return false;
    if (!('orderLeadtime' in value) || value['orderLeadtime'] === undefined) return false;
    if (!('orderLimitTime' in value) || value['orderLimitTime'] === undefined) return false;
    if (!('enableShipdayMon' in value) || value['enableShipdayMon'] === undefined) return false;
    if (!('enableShipdayTue' in value) || value['enableShipdayTue'] === undefined) return false;
    if (!('enableShipdayWed' in value) || value['enableShipdayWed'] === undefined) return false;
    if (!('enableShipdayThu' in value) || value['enableShipdayThu'] === undefined) return false;
    if (!('enableShipdayFri' in value) || value['enableShipdayFri'] === undefined) return false;
    if (!('enableShipdaySat' in value) || value['enableShipdaySat'] === undefined) return false;
    if (!('enableShipdaySun' in value) || value['enableShipdaySun'] === undefined) return false;
    if (!('enableSupplierShipday' in value) || value['enableSupplierShipday'] === undefined) return false;
    if (!('remarks' in value) || value['remarks'] === undefined) return false;
    if (!('deleteFlg' in value) || value['deleteFlg'] === undefined) return false;
    if (!('insertDatetime' in value) || value['insertDatetime'] === undefined) return false;
    if (!('insertUser' in value) || value['insertUser'] === undefined) return false;
    if (!('updateDatetime' in value) || value['updateDatetime'] === undefined) return false;
    if (!('updateUser' in value) || value['updateUser'] === undefined) return false;
    if (!('deleteDatetime' in value) || value['deleteDatetime'] === undefined) return false;
    if (!('deleteUser' in value) || value['deleteUser'] === undefined) return false;
    if (!('trMinOrderQuantityOnce' in value) || value['trMinOrderQuantityOnce'] === undefined) return false;
    if (!('trOrderLeadtime' in value) || value['trOrderLeadtime'] === undefined) return false;
    if (!('trOrderLimitTime' in value) || value['trOrderLimitTime'] === undefined) return false;
    if (!('orderTiming' in value) || value['orderTiming'] === undefined) return false;
    if (!('monthlyOrderLimitDay' in value) || value['monthlyOrderLimitDay'] === undefined) return false;
    if (!('monthlyOrderTarget' in value) || value['monthlyOrderTarget'] === undefined) return false;
    return true;
}

export function MstCenterSupplierFromJSON(json: any): MstCenterSupplier {
    return MstCenterSupplierFromJSONTyped(json, false);
}

export function MstCenterSupplierFromJSONTyped(json: any, ignoreDiscriminator: boolean): MstCenterSupplier {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
        'centerId': json['center_id'],
        'orgCenterId': json['org_center_id'],
        'orgSupplierId': json['org_supplier_id'],
        'optimizeType': json['optimize_type'],
        'optimizeRange': json['optimize_range'],
        'arrivalRatioMon': json['arrival_ratio_mon'],
        'arrivalRatioTue': json['arrival_ratio_tue'],
        'arrivalRatioWed': json['arrival_ratio_wed'],
        'arrivalRatioThu': json['arrival_ratio_thu'],
        'arrivalRatioFri': json['arrival_ratio_fri'],
        'arrivalRatioSat': json['arrival_ratio_sat'],
        'arrivalRatioSun': json['arrival_ratio_sun'],
        'stopArrival': json['stop_arrival'],
        'minOrderQuantityOnce': json['min_order_quantity_once'],
        'orderLeadtime': json['order_leadtime'],
        'orderLimitTime': json['order_limit_time'],
        'enableShipdayMon': json['enable_shipday_mon'],
        'enableShipdayTue': json['enable_shipday_tue'],
        'enableShipdayWed': json['enable_shipday_wed'],
        'enableShipdayThu': json['enable_shipday_thu'],
        'enableShipdayFri': json['enable_shipday_fri'],
        'enableShipdaySat': json['enable_shipday_sat'],
        'enableShipdaySun': json['enable_shipday_sun'],
        'enableSupplierShipday': json['enable_supplier_shipday'] == null ? null : json['enable_supplier_shipday'],
        'remarks': json['remarks'],
        'deleteFlg': json['delete_flg'],
        'insertDatetime': (json['insert_datetime'] == null ? null : new Date(json['insert_datetime'])),
        'insertUser': json['insert_user'],
        'updateDatetime': (json['update_datetime'] == null ? null : new Date(json['update_datetime'])),
        'updateUser': json['update_user'],
        'deleteDatetime': (json['delete_datetime'] == null ? null : new Date(json['delete_datetime'])),
        'deleteUser': json['delete_user'],
        'trMinOrderQuantityOnce': json['tr_min_order_quantity_once'],
        'trOrderLeadtime': json['tr_order_leadtime'],
        'trOrderLimitTime': json['tr_order_limit_time'],
        'orderTiming': json['order_timing'],
        'monthlyOrderLimitDay': json['monthly_order_limit_day'],
        'monthlyOrderTarget': json['monthly_order_target'],
    };
}

export function MstCenterSupplierToJSON(json: any): MstCenterSupplier {
    return MstCenterSupplierToJSONTyped(json, false);
}

export function MstCenterSupplierToJSONTyped(value?: MstCenterSupplier | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_id': value['companyId'],
        'center_id': value['centerId'],
        'org_center_id': value['orgCenterId'],
        'org_supplier_id': value['orgSupplierId'],
        'optimize_type': value['optimizeType'],
        'optimize_range': value['optimizeRange'],
        'arrival_ratio_mon': value['arrivalRatioMon'],
        'arrival_ratio_tue': value['arrivalRatioTue'],
        'arrival_ratio_wed': value['arrivalRatioWed'],
        'arrival_ratio_thu': value['arrivalRatioThu'],
        'arrival_ratio_fri': value['arrivalRatioFri'],
        'arrival_ratio_sat': value['arrivalRatioSat'],
        'arrival_ratio_sun': value['arrivalRatioSun'],
        'stop_arrival': value['stopArrival'],
        'min_order_quantity_once': value['minOrderQuantityOnce'],
        'order_leadtime': value['orderLeadtime'],
        'order_limit_time': value['orderLimitTime'],
        'enable_shipday_mon': value['enableShipdayMon'],
        'enable_shipday_tue': value['enableShipdayTue'],
        'enable_shipday_wed': value['enableShipdayWed'],
        'enable_shipday_thu': value['enableShipdayThu'],
        'enable_shipday_fri': value['enableShipdayFri'],
        'enable_shipday_sat': value['enableShipdaySat'],
        'enable_shipday_sun': value['enableShipdaySun'],
        'enable_supplier_shipday': value['enableSupplierShipday'],
        'remarks': value['remarks'],
        'delete_flg': value['deleteFlg'],
        'insert_datetime': value['insertDatetime'] == null ? value['insertDatetime'] : value['insertDatetime'].toISOString(),
        'insert_user': value['insertUser'],
        'update_datetime': value['updateDatetime'] == null ? value['updateDatetime'] : value['updateDatetime'].toISOString(),
        'update_user': value['updateUser'],
        'delete_datetime': value['deleteDatetime'] == null ? value['deleteDatetime'] : value['deleteDatetime'].toISOString(),
        'delete_user': value['deleteUser'],
        'tr_min_order_quantity_once': value['trMinOrderQuantityOnce'],
        'tr_order_leadtime': value['trOrderLeadtime'],
        'tr_order_limit_time': value['trOrderLimitTime'],
        'order_timing': value['orderTiming'],
        'monthly_order_limit_day': value['monthlyOrderLimitDay'],
        'monthly_order_target': value['monthlyOrderTarget'],
    };
}

